
import authInstance from "config/axios.config";

export const subsCriptionService ={
    getSubscription: async ({ page, limit, status, isPopular, search}) => {
        const params = new URLSearchParams({
            page: page?.toString() || "1",
            limit: limit?.toString() || "10",
            status: status || "",
            isPopular: isPopular || "",
            search: search || "",
        });

        // Remove empty params
        for (const [key, value] of [...params.entries()]) {
            if (!value) params.delete(key);
        }

        const res = await authInstance.get(`/admin/subscription?${params}`);
        return res.data;
    },

    getSubscriptionById: async (subscriptionId) => {
        const res = await authInstance.get(`/admin/subscription/${subscriptionId}`);
        return res.data;
    },

    addSubscription: async (subscriptionData) => {
        const res = await authInstance.post("/admin/subscription", subscriptionData);
        return res.data;
    },

    updateSubscription: async ({ subscriptionId, subscriptionData }) => {
        const res = await authInstance.patch(`/admin/subscription/${subscriptionId}`, subscriptionData);
        return res.data;
    },

    deleteSubscription: async (subscriptionId) => {
        const res = await authInstance.delete(`/admin/subscription/${subscriptionId}`);
        return res.data;
    },
}
